import React, { Component } from "react";
import { CheckCircle, XCircle, Loader2 } from "lucide-react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouterHooks } from "../../../../withRouters/withRoutersHook";

class MessageBroadCastStatus extends Component {
  static propTypes = {
    messageSuccessfullybroadcasted: PropTypes.bool,
  };

  render() {
    const { messageSuccessfullybroadcasted } = this.props;

    const isSuccess = messageSuccessfullybroadcasted === true;
    const isFailed = messageSuccessfullybroadcasted === false;
    const isPending = messageSuccessfullybroadcasted === null || messageSuccessfullybroadcasted === undefined;

    return (
      <div className="fixed inset-0 flex items-center justify-center bg-black/40 z-50">
        <div className="bg-white rounded-2xl shadow-xl px-10 py-10 flex flex-col items-center gap-4 w-full max-w-sm mx-4">
          {isPending && (
            <>
              <Loader2 className="w-12 h-12 text-primary-blue animate-spin" />
              <p className="font-SFPro font-bold text-lg text-gray-900 text-center">Sending bulk messages…</p>
              <p className="font-inter text-sm text-gray-500 text-center">Please wait while we send to all queued recipients.</p>
            </>
          )}
          {isSuccess && (
            <>
              <CheckCircle className="w-12 h-12 text-emerald-500" />
              <p className="font-SFPro font-bold text-lg text-gray-900 text-center">Bulk messages sent!</p>
              <p className="font-inter text-sm text-gray-500 text-center">All queued messages were delivered successfully.</p>
            </>
          )}
          {isFailed && (
            <>
              <XCircle className="w-12 h-12 text-red-500" />
              <p className="font-SFPro font-bold text-lg text-gray-900 text-center">Failed to send</p>
              <p className="font-inter text-sm text-gray-500 text-center">Something went wrong. Please try again.</p>
            </>
          )}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  messageSuccessfullybroadcasted: state.messaging.messageSuccessfullybroadcasted,
});

export default connect(mapStateToProps, {})(withRouterHooks(MessageBroadCastStatus));
